// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"9464d61c","74":"04600e68","228":"60a1e29d","433":"111f09bc"}[chunkId] + ".chunk.js";
};